export const UIClientTypes = {
    application: 'application',
    dashboard: 'dashboard',
    mobile: 'mobile',
};
//# sourceMappingURL=Token.js.map